export const componentsOutsideBlocks = ["Strapi_ComponentComponentSnackbar", "ComponentComponentSnackbar"];